import fetch from '@/api/fetch'

/**
 * 根据地址查询物流时效
 * params = {
 *   province     用户所在省份                        0
 *   city         用户所在市                          0
 *   skuCode      物料编码                            0
 *   skuId                                            0
 *   skuCount     sku选择的数量                       1
 *   isLaser      0 没有选择镭雕 1 选择了镭雕         1
 * }
 */
export function getTimelinessByAddress(params) {
  return fetch({
    url: '/v1/logistics/getTimelinessByAddress.json',
    params
  })
}

/**
 * 根据坐标查询物流时效
 * params = {
 *   longitude     经度                               0
 *   latitude      纬度                               0
 *   skuCode       物料编码                           0
 *   skuId                                            0
 *   skuCount      sku选择的数量                      1
 *   isLaser      0 没有选择镭雕 1 选择了镭雕         1
 * }
 */
export function getTimelinessByCoordinate(params) {
  return fetch({
    url: '/v1/logistics/getTimelinessByCoordinate.json',
    params
  })
}

/**
 * 获取所有地址数据
 */
export function getRegion(params) {
  return fetch({
    url: '/v1/my/address/getRegion',
    params
  })
}

/**
 * 获取用户已经保存的地址列表
 */
export function getAddressList(params) {
  return fetch({
    url: '/v1/my/address/list',
    unLogin: true,
    params
  })
}

/**
 * 获取热门城市
 */
export function getPopularCity(params) {
  return fetch({
    url: '/v1/address/popularCity',
    unLogin: true,
    params
  })
}

/**
 * 获取去地址选择器选择数据
 */
export function getaAddressData(params) {
  return fetch({
    url: '/v1/address/getAddresses',
    unLogin: true,
    params
  })
}
